// extracted by mini-css-extract-plugin
module.exports = {"bvWrapper":"BazaarVoiceReviewsQuestions_bvWrapper__aPYwW"};